/**
 * PolicyDetailContainer
 * --
 */
import React from 'react';
import PolicyDetailPresenter from './PolicyDetailPresenter';

const PolicyDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <PolicyDetailPresenter />
    </>
  );
};

export default PolicyDetailContainer;
